<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isCollapse: false,
      openIndex: [],
      activeIndex: "",
      menu: [],
      routers: [],
    };
  },
  mounted() {
    this.routers = JSON.parse(JSON.stringify(this.$router.options.routes));
    this.getMenu();
    this.activeIndex = this.breadcrumb.length ? this.breadcrumb[0].path : "";
  },
  watch: {
    "$store.state.breadcrumb": function (n, o) {
      this.activeIndex = this.breadcrumb[0].path || "";
    },
    "$store.state.myFuncKey": function (n, o) {
      this.routers = JSON.parse(JSON.stringify(this.$router.options.routes));
      this.getMenu();
    },
  },
  computed: {
    ...mapState(["breadcrumb", "myFuncKey"]),
  },
  methods: {
    getMenu() {
      this.menu = this.routers.filter((m) => {
        if (m.children) {
          // 只有一个子路由，路由名字一样，只显示路由不显示子路由
          if (m.children.length === 1 && m.children[0].meta.title === m.meta.title && this.hasPower(m.children[0])) {
            m.children = [];
            return true;
          }
          m.children = m.children.filter((c) => {
            return c.path && !c.meta.isInfo && this.hasPower(c);
          });
        }
        return this.hasPower(m) || (m.children && m.children.length > 0);
      });
    },
    hasPower(r) {
      return r.meta && (r.meta.funcKey === "" || this.myFuncKey.some((k) => k == r.meta.funcKey));
    },
    renderSubmit(h, parent) {
      if (parent.children && parent.children.length) {
        return (
          <el-submenu index={parent.path}>
            <template slot="title">
              <i class={["iconfont", parent.icon]}></i>
              <span>{parent.meta.title}</span>
            </template>
            {parent.children.map((child) => {
              return this.renderSubmit(h, child);
            })}
          </el-submenu>
        );
      } else if (parent.meta) {
        return (
          <el-menu-item key={parent.path} index={parent.path}>
            <template slot="title">
              <i class={["iconfont", parent.icon]}></i>
              <span>{parent.meta.title}</span>
            </template>
          </el-menu-item>
        );
      }
    },
  },
  render(h) {
    return (
      <el-menu
        router
        collapse={this.isCollapse}
        background-color="#001529"
        text-color="#ffffff"
        active-text-color="#ffffff"
        unique-opened
        default-openeds={this.openIndex}
        default-active={this.activeIndex}
      >
        {this.menu.map((data) => this.renderSubmit(h, data))}
      </el-menu>
    );
  },
};
</script>
<style lang="scss" scoped>
.el-menu {
  flex: 1;
  border-right: none;
}
::v-deep {
  .el-menu-item {
    padding-right: 10px;
    min-width: 100% !important;
    &.is-active {
      background-color: #006eff !important;
    }
  }
  .iconfont {
    color: #fff;
    margin-right: 12px;
  }
}
</style>
